import React from 'react';
import Product from "./Product"
import "./Home.css";

function Home() {
  return (
    <div className="home">
      <img
        className='home__image'
        src="https://pagecreative.co.uk/wp-content/uploads/2023/10/AdobeStock_223290240-1-2-scaled.jpeg"
        alt=""
      />
      
      {/* product id, title, price, rating, image */}
      <div className="home__row">
        <Product 
          id={123464}
          title="Instant Pot Duo 7-in-1 Electric Pressure Cooker"
          price={89.99}
          rating={3}
          image="https://images-na.ssl-images-amazon.com/images/I/81eB+7+CkUL._AC_SL1500_.jpg"
        />
        <Product 
          id={123459}
          title="Amazon Echo (4th Gen) | With premium sound, smart home hub, and Alexa"
          price={99.99}
          rating={4}
          image="https://images-na.ssl-images-amazon.com/images/I/71JB6hM6Z6L._AC_SL1000_.jpg"
        />
      </div>

      <div className="home__row"> 
        <Product 
          id={123465}
          title="Logitech MX Master 3S - Wireless Performance Mouse"
          price={299.99}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/I/71gD8WdSlaL._AC_SL1500_.jpg"
        />
        <Product 
          id={123457}
          title="Apple AirPods Pro (2nd Generation) with MagSafe Case"
          price={249.00}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/I/61f1YfTkTDL._AC_SL1500_.jpg"
        />
         <Product 
          id={123456}
          title="Atomic Habits: An Easy & Proven Way to Build Good Habits & Break Bad Ones"
          price={14.99}
          rating={4}
          image="https://images-na.ssl-images-amazon.com/images/I/91bYsX41DVL.jpg"
        />
      </div>

      <div className="home__row">
        <Product 
          id={123469}
          title="HP Pavilion 15 Laptop, 12th Gen Intel Core i7, 16GB RAM, 512GB SSD"
          price={849.99}
          rating={4}
          image="https://m.media-amazon.com/images/I/71s1LRpaprL._AC_SL1500_.jpg"
        />


      </div>
      {/* product */}
    </div>
  )
}

export default Home
